import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Footer from "./Layout/Footer";

function BlogDetailed() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`https://dashboard.maineautoparts.com/api/posts/${id}`);
        setPost(response.data);
      } catch (error) {
        console.error("Error fetching post details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [id]);

  if (loading) {
    return (
      <div>
        <div className="container" style={{ padding: "100px", textAlign: "center" }}>
          <span className="spinner-border text-primary" role="status"></span>
          <p>Loading post...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (!post) {
    return (
      <div>
        <div className="container text-center" style={{ padding: "100px" }}>
          <h2>Blog post not found</h2>
          <Link to="/blog" className="btn btn-primary" style={{ marginTop: "20px", backgroundColor: "#e06027", borderColor: "#e06027" }}>
            Back to Blog
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <div className="main-container container page" style={{ marginTop: "30px", marginBottom: "60px" }}>
        <ul className="breadcrumb">
          <li>
            <Link to="/">
              <i className="fa fa-home"></i>
            </Link>
          </li>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
          <li>{post.title}</li>
        </ul>

        <div className="row">
          <div className="col-md-10 offset-md-1">
            <div style={{ marginBottom: "20px", textAlign: "center" }}>
              <span style={{ fontSize: "14px", color: "#e06027", fontWeight: "bold", textTransform: "uppercase" }}>
                Published Article
              </span>
              <h1 style={{ color: "#1D2348", marginTop: "10px", fontSize: "36px", fontWeight: "bold" }}>
                {post.title}
              </h1>
              <p style={{ color: "#999", fontSize: "14px", marginTop: "10px" }}>
                Posted on{" "}
                {new Date(post.created_at).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>

            {post.image && (
              <div style={{ marginBottom: "30px", borderRadius: "10px", overflow: "hidden", maxHeight: "500px", width: "100%", display: "flex", justifyContent: "center", backgroundColor: "#f9f9f9" }}>
                <img
                  src={`https://dashboard.maineautoparts.com/storage/${post.image}`}
                  alt={post.title}
                  style={{ width: "100%", objectFit: "cover" }}
                />
              </div>
            )}

            <div
              className="blog-content"
              style={{
                fontSize: "16px",
                lineHeight: "1.8",
                color: "#333",
                marginTop: "30px",
              }}
              dangerouslySetInnerHTML={{ __html: post.body }}
            />

            <hr style={{ margin: "40px 0" }} />

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Link to="/blog" style={{ color: "#e06027", fontWeight: "bold", textDecoration: "none" }}>
                ← Back to Blog
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BlogDetailed;
